<template>
  <div class="baniere pb-20">
    <div
      class="w-full"
      data-aos="fade-right"
      data-aos-duration="2000"
    >
      <div class="titre md:w-4/5 w-full pr-4">
        Une prise en charge de bout en bout de l’ensemble du processus de prêt
      </div>
    </div>

    <div
      class="title1 mt-5 pr-0"
      data-aos="fade-up"
      data-aos-duration="2000"
    >
      Le système de montage de prêts DIGILOAN couvre le processus de prêt depuis la première interaction avec les prospects jusqu'au décaissement.
      L'ensemble du cycle de vie du crédit est pris en charge par la norme Camunda BPM intégrée au sein de la gestion des flux de travail et des documents de DIGILOAN. Cette solution unifie le montage des prêts, les processus de flux de crédit et l'administration des prêts et des garanties. et toute administration connexe des prêts et des garanties. Cette solution modulaire a été mise en œuvre avec succès dans des environnements bancaires complexes.
      L'application comprend le flux de travail complet de prêt et de tarification avec différentes interfaces pour différents objectifs d'application. Le système DIGILOAN contient des fonctionnalités intégrées de front et de back office.
      Il peut accélérer le processus de demande de crédit avec une expérience client transparente. L'objectif du développement était de réduire le délai de décision pour les utilisateurs internes et le délai de paiement pour les clients de la banque.
    </div>

    <div class="text-center mt-10">
      <img
        src="../../../assets/images/jpg/graph.jpg"
        alt=""
        class=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.baniere{
  height: auto ;
  background-color: $white;
  position: relative;
  padding-left: $padding-l;
  padding-right: $padding-r;
}

.titre{
  font-weight: 800;
  font-size: 40px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $black;
}
.title1{
  font-weight: normal;
  font-size: 24px;
  line-height: 160%;
  color: $black;
}

@media screen and (max-width: 600px){
  .baniere{
    padding-left: 20px;
    padding-right: 20px;
  }
  .titre{
    font-size: 28px;
  }
  .title1{
    font-size: 18px;
  }
}
@media screen and (min-width: 701px) and (max-width: 1024px){
  .baniere{
    padding-left: $padding-l-1024;
    padding-right: $padding-r-1024;
  }
  .titre{
    font-size: 30px;
  }
  .titre1{
    font-size: 20px;
  }

  .blocc {
    padding: 30px;
  }
}

</style>
